import React, { useState, useEffect } from "react";
import PageHeader1 from "../../components/common/PageHeader1";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { GetJournalsList,handleDeleteJournal} from "../../services/Journals";

function JournalsList() {
  const [isLoading, setIsLoading] = useState(true);
  const [stories, setStories] = useState([]);

  // ✅ Fetch Sleep Stories
  const getJournals = async () => {
    setIsLoading(true);
    try {
      const response = await GetJournalsList();
      console.log("Journals response:", response);
      if (response.success === false) {
        toast.error(response.message || "Failed to load sleep storiesd");
        return;
      }

      // Response format:
      // { message: "Playlists fetched", data: [ ... ] }
      const data = response.data || [];

      setStories(
        data.map((item, index) => ({
          id: item._id,
          sno: index + 1,
          prompt_title: item.prompt_id?.title || "N/A",
          prompt: item.prompt_id?.prompt || "N/A",
          mood: item.mood,
          transcription: item.transcription,
          first_name: item.user_id?.first_name || "N/A",
          last_name: item.user_id?.last_name || "",
          recorded_voice: item.recorded_voice,
          createdAt: item.createdAt || item.created_at,
        }))
        
      );
      console.log("Mapped journals data:", data)
    } catch (error) {
      console.error("Error fetching sleep stories:", error);
      toast.error("Failed to load sleep storiessss");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJournals();
  }, []);

  // ✅ DataGrid Columns
  const columns = [
    { field: "sno", headerName: "S.No", width: 80 },
    { field: "prompt_title", headerName: "Prompt Title", width: 250 },
    { field: "prompt", headerName: "Prompt", width: 150 },
    { field: "first_name", headerName: "First Name", width: 140 },
    { field: "last_name", headerName: "Last Name", width: 140 },
    { field: "mood", headerName: "Mood", width: 120 },
    { field: "transcription", headerName: "Transcription", width: 120 },
   
    {
      field: "recorded_voice",
      headerName: "Recorded Voice",
      width: 180,
      renderCell: (params) =>
        params.row.recorded_voice ? (
          <audio controls style={{ width: "100%" }}>
            <source src={params.row.recorded_voice} type="audio/mp3" />
          </audio>
        ) : (
          <span>No Audio</span>
        ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 180,
      renderCell: (params) =>
        new Date(params.row.createdAt).toLocaleString("en-IN"),
    },
    {
          field: "action",
          headerName: "Action",
          width: 150,
          renderCell: (params) => (
            <div className="btn-group">
              
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                 onClick={() => handleDeleteJournal(params.row.id, getJournals)}
               
              >
                <i className="icofont-ui-delete"></i>
              </button>
            </div>
          ),
        },
  ];

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1 pagetitle="Journals List" />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <DataGrid
                  rows={stories}
                  columns={columns}
                  loading={isLoading}
                  autoHeight
                  disableSelectionOnClick
                  pageSize={10}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  sx={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JournalsList;
